import { render, staticRenderFns } from "./hotel-order.vue?vue&type=template&id=4d7925ce&scoped=true"
import script from "./hotel-order.vue?vue&type=script&lang=ts"
export * from "./hotel-order.vue?vue&type=script&lang=ts"
import style0 from "./hotel-order.vue?vue&type=style&index=0&id=4d7925ce&prod&scoped=true&lang=css"
import style1 from "./hotel-order.vue?vue&type=style&index=1&id=4d7925ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7925ce",
  null
  
)

export default component.exports